import type { MessageDescriptor } from "react-intl";

import { isNetworkName } from "./guards";
import { networkCodesMessages } from "./messages";

export const getNetworkUIName = (slug?: string): MessageDescriptor => {
  if (isNetworkName(slug)) {
    return networkCodesMessages[slug];
  }

  return { id: slug || "-" };
};
